import * as React from 'react';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ContentLayout from 'components/common/layouts/ContentLayout';
import SearchFilter from 'components/member/closet/SearchFilter';
import MemberListTable from 'components/member/closet/MemberListTable';
import {
  memberListActions,
  selectMailListExportData,
  selectMailListExportLoading,
  selectMailListExportReady,
  selectMarketingAgreeExportData,
  selectMarketingAgreeExportLoading,
  selectMarketingAgreeExportReady,
  selectMemberList,
  selectMemberListLoading,
} from 'features/member/reducer/memberListSlice';
import { ExcelMemberExport } from 'types/member';
import useClosetMemberSearchFilter from 'hooks/useClosetMemberSearchFilter';

const MemberClosetContainer = () => {
  const dispatch = useDispatch();
  const { items: memberList, totalPages, totalItems } = useSelector(selectMemberList);
  const memberListLoading = useSelector(selectMemberListLoading);
  const mailListExportData = useSelector(selectMailListExportData);
  const mailListExportReady = useSelector(selectMailListExportReady);
  const mailListExportLoading = useSelector(selectMailListExportLoading);
  const marketingAgreeExportData = useSelector(selectMarketingAgreeExportData);
  const marketingAgreeExportReady = useSelector(selectMarketingAgreeExportReady);
  const marketingAgreeExportLoading = useSelector(selectMarketingAgreeExportLoading);
  const mailListExportRef = useRef<HTMLButtonElement>(null);
  const marketingAgreeExportRef = useRef<HTMLButtonElement>(null);

  const {
    currentPageIndex,
    keyword,
    userStatus,
    onChangeKeyword,
    onKeyDownKeyword,
    onChangeUserStatus,
    getSearchResult,
    resetFilter,
    onChangePage,
  } = useClosetMemberSearchFilter();

  useEffect(() => {
    // excel export (mail list)
    if (mailListExportData.length && mailListExportRef.current && mailListExportReady) {
      mailListExportRef.current.click();
      dispatch(memberListActions.setMailListExportReady(false));
    }
    // excel export (marketing agree)
    if (
      marketingAgreeExportData.length &&
      marketingAgreeExportRef.current &&
      marketingAgreeExportReady
    ) {
      marketingAgreeExportRef.current.click();
      dispatch(memberListActions.setMarketingAgreeExportReady(false));
    }
  }, [
    mailListExportData,
    mailListExportReady,
    marketingAgreeExportData,
    marketingAgreeExportReady,
  ]);

  const onClickMailListExport = () => {
    dispatch(memberListActions.getMailListExportData({ type: ExcelMemberExport.All, keyword }));
  };

  const onClickMarketingAgreeExport = () => {
    dispatch(
      memberListActions.getMarketingAgreeExportData({
        type: ExcelMemberExport.CLOSET_MARKETING,
        keyword,
      }),
    );
  };

  return (
    <ContentLayout pageTitle={'Member'}>
      <SearchFilter
        keyword={keyword}
        onChangeKeyword={onChangeKeyword}
        onKeyDownKeyword={onKeyDownKeyword}
        userStatus={userStatus}
        onChangeUserStatus={onChangeUserStatus}
        onClickSearch={getSearchResult}
        onClickReset={resetFilter}
      />
      <MemberListTable
        memberListLoading={memberListLoading}
        totalPages={totalPages}
        onChangePage={onChangePage}
        currentPageIndex={currentPageIndex}
        memberList={memberList}
        refs={{ mailListExportRef, marketingAgreeExportRef }}
        mailListExportData={mailListExportData}
        mailListExportLoading={mailListExportLoading}
        marketingAgreeExportData={marketingAgreeExportData}
        marketingAgreeExportLoading={marketingAgreeExportLoading}
        onClickMailListExport={onClickMailListExport}
        onClickMarketingAgreeExport={onClickMarketingAgreeExport}
        totalItems={totalItems}
      />
    </ContentLayout>
  );
};

export default MemberClosetContainer;
